import { Button, Divider, Form, Grid, Input, Text } from '@wework/dieter-ui'
import React from 'react'
import IMTheme from '../../style/IMTheme'
import { Radio } from 'semantic-ui-react'
import { Lock } from '../Icons'
import css from './EditSchedule.module.scss'

export default function EditSchedule() {
  return (
    <>
      <Grid style={{ marginTop: IMTheme.spacing[5] }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text className={css.attributeTitle}>
                <b>Schedule</b>
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row>
          <Grid.Column width={8}>
            <Text className={css.subTitle}>Booking threshold</Text>
            <Text className={css.attributeDesc} size="small">
              How many days in the future a room can be booked. Set to off for
              no limit.{' '}
            </Text>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid>
              <Grid.Row>
                <Grid.Column width={8}>
                  <Form.Field>
                    <Radio label="On" name="threshold" toggle />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Form.Field
                    label="Days"
                    control={Input}
                    type="string"
                    size="small"
                    value="7"
                    defaultValue="7"
                    className="noOpacity"
                    outline
                    fluid
                    style={{ marginBottom: 24 }}
                    icon={
                      <div
                        style={{
                          position: 'absolute',
                          right: 5,
                          top: 10,
                          cursor: 'pointer',
                        }}
                      >
                        <Button
                          icon={<Lock />}
                          style={{ padding: 0, background: 'white' }}
                        />
                      </div>
                    }
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text size="small" className={css.attributeDesc}>
                To make any changes to this, please use{' '}
                <a href="https://rooms.wework.com/">Rooms Admin</a>.
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider light style={{ width: '100%' }} />
      <Grid style={{ marginTop: IMTheme.spacing[5] }}>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text className={css.subTitle}>
                <b>Schedule by membership type</b>
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column>
            <div>
              <Text size="small" className={css.attributeDesc}>
                Set open and close times for this room according to membership
                type. Time is shown in this location's timezone. (GMT +08).{' '}
                <br />
                <br />
                To make any changes to this, please use{' '}
                <a href="https://rooms.wework.com/">Rooms Admin.</a>
              </Text>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Grid>
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.physical}>PHYSICAL</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Weekday</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.digital}>DIGITAL</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Mon - Tue</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Wed - Fri</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 2100</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.hotdesk}>HOTDESK</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Mon</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Tue</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0900 – 2100</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Wed</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1830</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Thu</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0930 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Fri</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>1200 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.emplooyee}>EMPLOYEE</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row
                      stretched
                      style={{
                        paddingTop: '0',
                        paddingBottom: '0',
                      }}
                    >
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0800 – 2100</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={'css.attributeColumnForTypes'}>
            <div>
              <label className={css.pxwe}>PXWE</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row
                      stretched
                      style={{
                        paddingTop: '0',
                        paddingBottom: '0',
                      }}
                    >
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Mon - Wed</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row
                      stretched
                      style={{
                        paddingTop: '0',
                        paddingBottom: '0',
                      }}
                    >
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Thu</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0900 – 2100</text>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row
                      stretched
                      style={{
                        paddingTop: '0',
                        paddingBottom: '0',
                      }}
                    >
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                        }}
                      >
                        <text>Weekends</text>
                      </Grid.Column>
                      <Grid.Column
                        width={8}
                        style={{
                          width: '50%',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                      >
                        <text>0800 – 1200</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.globalAccess}>GLOBAL ACCESS</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text color={IMTheme.colors.darkerGray}>
                          Not Available
                        </text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Divider light style={{ width: '100%' }} />
        <Grid.Row stretched>
          <Grid.Column width={8} className={css.attributeColumnForTypes}>
            <div>
              <label className={css.onDemand}>ON DEMAND</label>
              <br />
              <label className={css.onDemandSub}>ON DEMAND SUBSCRIPTION</label>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <Grid className={css.schedules}>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Home</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Daily</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 1800</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column width={8}>
                  <text>
                    <b>Visiting</b>
                  </text>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row stretched>
                <Grid.Column>
                  <Grid>
                    <Grid.Row stretched className={css.schedulesRow}>
                      <Grid.Column width={8}>
                        <text>Weekday</text>
                      </Grid.Column>
                      <Grid.Column width={8} className={css.schedulesCol}>
                        <text>0800 – 2100</text>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  )
}
